import gql from 'graphql-tag'

const fetchDelegations = () => {
	return {
		query: gql`
			{
				organizations_delegations(
					order_by: { active: desc, delegation_name: asc }
				) {
					id
					delegation_name
					organizations_zone {
						zone_name
					}
					state {
						name
					}
					phone
					email
					active
				}
			}
		`,
		update(data) {
			return data.organizations_delegations.map(item => ({
				id: item.id,
				name: item.delegation_name,
				zone: item.organizations_zone.zone_name,
				state: item.state ? item.state.name : '',
				phone: item.phone,
				email: item.email,
				office: '/admin/listado/oficinas/' + item.id,
				edit: true,
				active: item.active
			}))
		}
	}
}

export { fetchDelegations }
